import React from 'react';

const LandingPageFooter = () => {
  const departments = [
    "Water Resources Department",
    "Rural Development and Panchayats Raj", 
    "Town Panchayats",
    "Greater Chennai Corporation",
    "Municipal Administration",
    "Hindu Religious Charitable",
    "Environment, Climate Change & Forest"
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        .footer-font {
          font-family: 'Inter', system-ui, sans-serif;
        }
      `}</style>
      
      <footer className="bg-gradient-to-br from-slate-800 via-slate-900 to-blue-900 text-white footer-font">
        <div className="container mx-auto px-8 py-16">
          <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-12">
            
            {/* NOC Application Portal Section */}
            <div className="lg:col-span-2">
              <div className="flex items-center mb-6">
                <img 
                  src="/images/tnlogo.png" 
                  alt="Tamil Nadu Government Logo" 
                  className="w-16 h-16 mr-4 bg-white rounded-lg p-2 shadow-lg"
                  onError={(e) => {
                    // Fallback if logo image fails to load
                    e.target.style.display = 'none';
                    e.target.nextElementSibling.style.display = 'flex';
                  }}
                />
                <div className="w-16 h-16 bg-white rounded-lg flex items-center justify-center mr-4 shadow-lg" style={{display: 'none'}}>
                  <div className="text-center">
                    <div className="text-blue-600 font-bold text-xs">GOVT OF</div>
                    <div className="text-blue-800 font-bold text-sm">TAMIL NADU</div>
                    <div className="text-blue-600 text-xs">WRD</div>
                  </div>
                </div>
                <h3 className="text-2xl font-semibold">NOC Application Portal</h3>
              </div>
              <p className="text-slate-300 leading-relaxed mb-6 text-lg">
                Tamil Nadu's comprehensive digital platform for water resource management and NOC applications. 
                Streamlining processes across multiple government departments to ensure efficient water resource 
                governance and community participation in sustainable water management practices.
              </p>
            </div>

            {/* Quick Links - Departments */}
            <div>
              <h4 className="text-xl font-semibold mb-6 flex items-center">
                <svg className="w-5 h-5 mr-2 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                </svg>
                Quick Links
              </h4>
              <ul className="space-y-3">
                {departments.map((dept, index) => (
                  <li key={index}>
                    <a 
                      href="#" 
                      className="text-slate-300 hover:text-white transition-colors text-sm leading-relaxed hover:underline"
                    >
                      {dept}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Information */}
            <div>
              <h4 className="text-xl font-semibold mb-6 flex items-center">
                <svg className="w-5 h-5 mr-2 text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                Contact Us
              </h4>
              <div className="space-y-4">
                <div className="flex items-start">
                  <svg className="w-5 h-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                    <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                  </svg>
                  <div>
                    <div className="text-slate-300 text-sm">Email</div>
                    <a href="mailto:noc@tnwater.gov.in" className="text-white hover:text-blue-400 transition-colors">
                      noc@tnwater.gov.in
                    </a>
                  </div>
                </div>
                
                <div className="flex items-start">
                  <svg className="w-5 h-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                  <div>
                    <div className="text-slate-300 text-sm">Address</div>
                    <div className="text-white text-sm leading-relaxed">
                      Water Resources Department<br />
                      Secretariat, Chennai - 600009<br />
                      Tamil Nadu, India
                    </div>
                  </div>
                </div>

                <div className="flex items-start">
                  <svg className="w-5 h-5 text-blue-400 mr-3 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                  </svg>
                  <div>
                    <div className="text-slate-300 text-sm">Phone</div>
                    <a href="tel:+914428962500" className="text-white hover:text-blue-400 transition-colors">
                      +91 44 2896 2500
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Section */}
          <div className="border-t border-slate-700 mt-12 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <div className="text-slate-400 text-sm mb-4 md:mb-0">
                © 2024 Government of Tamil Nadu. All rights reserved.
              </div>
              <div className="flex space-x-6 text-sm">
                <a href="#" className="text-slate-400 hover:text-white transition-colors">Privacy Policy</a>
                <a href="#" className="text-slate-400 hover:text-white transition-colors">Terms of Service</a>
                <a href="#" className="text-slate-400 hover:text-white transition-colors">Help</a>
                <a href="#" className="text-slate-400 hover:text-white transition-colors">Sitemap</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default LandingPageFooter;